import type { DialogueData, DialogueNode } from '@/core/types/contracts';

export type LineSpec = Omit<DialogueNode, 'id' | 'next'> & { id?: string; next?: string };

/** Builds a linear dialogue: each line flows to the next unless it sets `next` itself. */
export function linear(id: string, lines: LineSpec[]): DialogueData {
  const nodes: DialogueNode[] = lines.map((l, i) => {
    const nid = l.id ?? `n${i}`;
    const nextDefault = i < lines.length - 1 ? (lines[i + 1]?.id ?? `n${i + 1}`) : undefined;
    return { ...l, id: nid, next: l.next ?? nextDefault };
  });
  return { id, start: nodes[0]?.id ?? 'n0', nodes };
}

/** Narration / observation line (no speaker). */
export function narr(text: string, extra: Partial<LineSpec> = {}): LineSpec { return { text, ...extra }; }
/** Letter-voice narration: `emotion: 'letter'` hints the box to style it as the letter. */
export function letter(text: string, extra: Partial<LineSpec> = {}): LineSpec { return { text, emotion: 'letter', ...extra }; }
/** Spoken line; `speaker` is an ACTOR_DEFS key (see SPEAKER in ../actors.ts) or a literal name. */
export function say(speaker: string, text: string, extra: Partial<LineSpec> = {}): LineSpec { return { speaker, text, ...extra }; }
